import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OrganizationUnit } from 'src/app/misc/interface/organization-unit';
import { CryptoService } from 'src/app/services/crypto.service';
import { DataService } from 'src/app/services/data.service';
import { GlobalConstants } from 'src/app/services/global-constants';

@Component({
  selector: 'app-category-searchbar',
  templateUrl: './category-searchbar.component.html',
  styleUrls: ['./category-searchbar.component.scss']
})
export class CategorySearchbarComponent {


  @Input() colors: string[] = ['#300a3b', '#2a0450', '#082f4e', '#011941', '#110d49'];

  @Input() searchText = '';

  @Input() ou?: number;


  isLoggedIn = JSON.parse(localStorage.getItem('isLoggedIn') || "false");


  recentsearches: any = []

  showItems = true;
  parents: OrganizationUnit[] = [];
  count: number = 0;
  searchQueryObject: any;
  currentOu: any;

  activeChip: string | null = null;

  checkisImg(arg0: string | undefined): any {
    if (arg0) {
      return /\.(jpg|jpeg|png|gif|svg)/.test(arg0);
    } else {
      return false
    }
  }

  constructor(private dataService: DataService, private router: Router, private route: ActivatedRoute, private cryptoService: CryptoService,) { }

  async ngOnInit() {
    if (this.isLoggedIn) {
      this.fetchRecentSearches();
    }
    console.log("parents", this.parents);
    if (this.searchText == 'all') {
      this.searchText = ''
    } else {
      try {
        // If searchText is URI-encoded, decode it
        if (this.searchText !== decodeURI(this.searchText)) {
          this.searchText = decodeURI(this.searchText);
        }
      } catch (e) {
        // If decodeURI fails (malformed URI), leave searchText as is
      }
    }

    this.currentOu = await this.getById();

    this.route.queryParams.subscribe(async (params) => {
      this.searchQueryObject = params['query'] ? decodeURI(params['query']) : null;
    });
  }

  async fetchRecentSearches() {
    try {
      let res = await this.dataService.getData('ou/search-history');
      console.log("RES", res);
      this.recentsearches = res.data.reverse();
      if (this.recentsearches.length > 10) {
        this.recentsearches = this.recentsearches.splice(0, 10)
      }
    } catch (e) {
      console.log(e);
    }
  }

  async getById() {
    try {
      let res = await this.dataService.getData('ou/byId?id=' + this.ou);
      console.log("RES", res);
      while (
        res.data &&
        res.data.length > 0 &&
        res.data[0].parent != null &&
        res.data[0].type != "64648e7118d4943a0a7b366c"
      ) {
        if (res.data[0].parent.id) {
          res = await this.dataService.getData('ou/byId?id=' + res.data[0].parent.id);
        } else {
          res = await this.dataService.getData('ou/byId?id=' + res.data[0].parent);
        }
      }
      return res.data && res.data.length > 0 ? res.data[0] : null;
    } catch (e) {
      console.log(e);
      return null;
    }
  }

  gotoAdvanceSearch(arg0: any) {
    let queryParams = { query: this.searchQueryObject };
    this.router.navigate(['/advance-search'], { queryParams }).then(() => {
      // Force a full page reload after the route change is complete
      location.reload();
    });
  }



  navigateToSearch(event: any) {
    let term = event.target.value;
    if (term == '') {
      term = 'all'
    }
    if (term.includes("\"") || term.includes("+") || term.includes("-")) {
      this.advancedSearch(term);
      return;
    }

    
    if (this.ou) {
      let queryParams = { ou: this.ou, searchTerm: encodeURI(term) };
      this.router.navigate(['/search-view'], { queryParams }).then(() => {
        // Force a full page reload after the route change is complete
        location.reload();
      });
    } else {
      let queryParams = { searchTerm: encodeURI(term) };
      this.router.navigate(['/search-view'], { queryParams }).then(() => {
        // Force a full page reload after the route change is complete
        location.reload();
      });
    }
  }

  advancedSearch(search: string) {
    let query: any = { condition: 'and', rules: [] };
    query.extras = this.extractSearchParts(search);
    if (this.ou) {
      query.extras.ou = this.ou;
    }
    let encryptedQuery = this.cryptoService.encodeObject(query);
    let params = {
      query: encryptedQuery,
      searchTerm: encodeURI(search || '')
    };
    this.router.navigate(['/advance-search/result'], { queryParams: params })
  }

  extractSearchParts(search: string) {
    const removal: string[] = [];
    const exact: string[] = [];
    const any: string[] = [];

    // Handle exclusion phrases first to avoid losing the preceding "-"
    search = search.replace(/(^|\s)-\s*"([^"]+)"/g, (_, prefix: string, match: string) => {
      removal.push(match.trim());
      return prefix ? `${prefix} ` : ' ';
    });

    // Handle exclusion single words (with or without whitespace after "-")
    search = search.replace(/(^|\s)-\s*([^\s"]+)/g, (_, prefix: string, match: string) => {
      removal.push(match.trim());
      return prefix ? `${prefix} ` : ' ';
    });

    // Extract exact match parts that are not exclusions
    search = search.replace(/"([^"]+)"/g, (_, match: string) => {
      exact.push(match.trim());
      return ' ';
    });

    // Remaining parts (any match) after removing '+' tokens and trimming
    const remainingParts = search.replace(/\+/g, ' ').trim();
    if (remainingParts) {
      remainingParts.split(/\s+/).forEach(part => {
        if (part.trim()) {
          any.push(part.trim());
        }
      });
    }

    const query: any = {};
    if (any.length) {
      query.likeAll = any.join(' ');
    }
    if (exact.length) {
      query.sameWord = exact.join(' ').replaceAll('+', '');
    }
    if (removal.length) {
      query.notContains = removal.join(' ').replaceAll('+', '');
    }
    return query;
  }

  staticURL = GlobalConstants.staticFilesURL;

}